import { useEffect, useState } from "react";
import { Container, Tab, Tabs } from "react-bootstrap";
import { getEtapas, getOrg, setOrgToken } from "../../controllers/org";
import { useAuth } from "../../components/auth/AuthProvider";
import Loading from "../../components/loading/Loading";
import Members from "./Members";
import { getDashboard } from "../../controllers/dashboard";
import AdminDashboard from "../../components/dashboard/AdminDashboard";
import ErrorAlert from "../../components/errors/ErrorAlert";
import OrdersNacional from "../../components/tesoreria/orders-nacional";
import TransaccionesComunidad from "./TransaccionesComunidad";
import Products from "../../components/tesoreria/products";

function Nacional() {
  const { token } = useAuth();
  const [org, setOrg] = useState();
  const [cards, setCards] = useState([]);
  const [errorCode, setErrorCode] = useState(); 
  setOrgToken(token);

  useEffect(() => {
    document.title = 'FAMA - Dashboard Nacional'
    loadData();
    loadDashboard();
  }, []);

  async function loadData() {
    let o = await getOrg();
    setOrg(o);

    // Cargar etapas para la cache,
    // para que estén disponibles en los forms de tesorería
    // y solo se carguen una vez.
    await getEtapas();
  }

  async function loadDashboard() {
    let d = await getDashboard(token);
    console.log('cards', d);
    setCards(d.cards);
  }

  if (errorCode) {
    return <Container className='pt-5 pb-5'>
      <ErrorAlert code={errorCode} />
    </Container>;
  }
  if (!cards.length) {
    return <Container className='pt-5 pb-5'>
      <Loading text="Cargando..." />
    </Container>;
  }

  return <Container className='pt-5 pb-5 org-nacional'>
      <h1>Nacional</h1>
      <Tabs>
        <Tab eventKey="resumen" title="Resumen">
          <AdminDashboard data={cards} showMembersButton={false} regiones={org.regiones} />    
        </Tab>
        <Tab eventKey="miembros" title="Miembros">
          <Members />
        </Tab>
        <Tab eventKey="tesoreros" title="Tesorería" mountOnEnter={true} unmountOnExit={true}>
          <Tabs>
            <Tab eventKey="ordenes" title="Órdenes de material" mountOnEnter={true} unmountOnExit={true}>
              <OrdersNacional />
            </Tab>
            <Tab eventKey="transacciones" title="Transacciones por Comunidad" mountOnEnter={true} unmountOnExit={true}>
              <TransaccionesComunidad />
            </Tab>
            <Tab eventKey="productos" title="Productos" mountOnEnter={true} unmountOnExit={true}>
              <Products />
            </Tab>
          </Tabs>
        </Tab>
      </Tabs>
  </Container>;
}

export default Nacional;
